import ContractDetailed from "../../components/ContractDetailed";
import WithFetchContract from "../WithFetchContract/index";
import { setDisplayName, withHandlers, compose, withProps } from "recompose";
import { connect } from "react-redux";
import { actions } from "../../modules/contracts";
import {
  getConfirmedItems,
  getRequiredItems,
  getCompletedItems
} from "../../modules/items";
import { continueKeys } from "../../helpers/index";

const mapStateToProps = state => ({
  submittingContract: state.contracts.submittingContract,
  failSubmitContract: state.contracts.failSubmitContract,
  items: state.items.items,
  requiredItems: getRequiredItems(state),
  confirmedItems: getConfirmedItems(state),
  completedItems: getCompletedItems(state),
  role: state.settings.role
});

const mapActionCreators = {
  updateContract: actions.updateContract,
  setCurrentContract: actions.setCurrentContract
};

const withContinue = withHandlers({
  onClickTransition: ({
    updateContract,
    currentContract,
    setCurrentContract
  }) => transition => () => {
    const data = { [transition]: true };
    if (
      [
        "approve_diagnostic",
        "waiting_for_invoice",
        "waiting_for_payment",
        "waiting_for_pickup"
      ].includes(currentContract.aasm_state)
    ) {
      data[continueKeys[currentContract.aasm_state]] = true;
    }
    updateContract({
      dealer_id: currentContract.dealer.id,
      contract_id: currentContract.tracking_number,
      data
    }).then(contract => {
      setCurrentContract(contract);
    });
  }
});

export default compose(
  setDisplayName("ContractShow"),
  WithFetchContract,
  connect(
    mapStateToProps,
    mapActionCreators
  ),
  withContinue,
  //WithContractSocket,
  withProps(({ currentContract }) => ({ contract: currentContract }))
)(ContractDetailed);
